module.exports = __webpack_public_path__ + "img/pin.c1bb5857.png";